import { openDB } from 'idb';

const DB_NAME = 'Baseball5DB';
const STORE_GAME = 'games';
const STORE_SCORE = 'score';
const STORE_PLAYER = 'players';
const STORE_PLAYER_STATS = 'playersStats';
const STORE_OFFICIALS = 'officials';

const initDB = async () => {
    return openDB(DB_NAME, 6, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_GAME)) {
                db.createObjectStore(STORE_GAME, { keyPath: 'id', autoIncrement: true });
            }
            if (!db.objectStoreNames.contains(STORE_PLAYER)) {
                db.createObjectStore(STORE_PLAYER, { keyPath: 'id', autoIncrement: true });
            }
            if (!db.objectStoreNames.contains(STORE_PLAYER_STATS)) {
                db.createObjectStore(STORE_PLAYER_STATS, { keyPath: 'id', autoIncrement: true });
            }
            if (!db.objectStoreNames.contains(STORE_SCORE)) {
                db.createObjectStore(STORE_SCORE, { keyPath: 'id', autoIncrement: true });
            }
            if (!db.objectStoreNames.contains(STORE_OFFICIALS)) {
                db.createObjectStore(STORE_OFFICIALS, { keyPath: 'id', autoIncrement: true });
            }
        }
    });
};
export default function handleIndexedDB(endpoint, data) {
    switch (endpoint) {
        case "saveGame":
            return saveGame(data);
        case "getGame":
            return loadGame(data.id);
        case "getAllGames":
            return loadAllGames();
        case "getAllGamesResult":
            return loadAllGamesResult();
        case "deleteGame":
            return deleteGame(data.id);
        case "players":
            return loadPlayer(data);
        case "getplayerstats":
            return loadPlayerStats(data);
        case "playerstats":
            return savePlayerStats(data.player, data);
        case "saveScore":
            return saveScore(data);
        case "getScore":
            return loadScore(data.id);
        case "saveOfficial":
            return saveOfficial(data);
        case "getOfficial":
            return loadOfficial(data.id);
        case "getAllOfficials":
            return loadAllOfficials();
        case "deleteOfficial":
            return deleteOfficial(data.id);
        default:
            throw new Error(`Unknown endpoint: ${endpoint}`);
    }
}

export const saveGame = async (game) => {
    const db = await initDB();
    await db.put(STORE_GAME, { id: game.id, game: JSON.parse(JSON.stringify(game.game)) });
};

export const loadGame = async (id) => {
    const db = await initDB();
    return await db.get(STORE_GAME, Number(id));
};

export const loadAllGames = async () => {
    const db = await initDB();
    return await db.getAll(STORE_GAME);
}

export const loadAllGamesResult = async () => {
    const db = await initDB();
    const allGames = await db.getAll(STORE_GAME);

    return allGames.map((entry, index) => {
       // Nehme den ersten Eintrag im game.game Array (oder überprüfe weitere Elemente, falls benötigt)
        const gameData = Array.isArray(entry?.game) ? entry.game[0] : null;

        // Prüfen, ob gameData vorhanden ist, und Teamnamen extrahieren
        const homeTeam = gameData?.game?.home?.team || "Home Team";
        const guestTeam = gameData?.game?.guest?.team || "Guest Team";

        return {
            id: entry?.id || `Unknown ID ${index}`, // Fallback-ID
            name: `${guestTeam} vs ${homeTeam}`, // Formatierter Spielname
            score: `${gameData?.game?.guest?.score }:${gameData?.game?.home?.score }`, // Formatierter Spielname
            inning: gameData?.game?.inning || 1,
            status: gameData?.game?.status || false
        };
    });
};

export const deleteGame = async (id) => {
    const db = await initDB();
    await db.delete(STORE_GAME, id);
};

export const savePlayer = async (player) => {
    const db = await initDB();
    await db.put(STORE_PLAYER, { id: player.id, player: JSON.parse(JSON.stringify(player)) });
};

export const loadPlayer = async (id) => {
    const db = await initDB();
    return await db.get(STORE_PLAYER, Number(id));
};

export const deletePlayer = async (id) => {
    const db = await initDB();
    await db.delete(STORE_PLAYER, id);
};
export const loadAllPlayers = async () => {
    const db = await initDB();
    const allPlayers = await db.getAll(STORE_PLAYER);
    return allPlayers.map(entry => entry.player);
};

export const loadPlayerStats = async (id) => {
    const db = await initDB();
    return await db.get(STORE_PLAYER_STATS, Number(id));
};
export const savePlayerStats = async (playerId, newStats) => {
    const db = await initDB();

    // Lade den bestehenden Spieler aus der Datenbank
    const existingPlayerEntry = await db.get(STORE_PLAYER_STATS, playerId);

    let updatedStats;

    if (!existingPlayerEntry) {
        // Kein Eintrag vorhanden, neuen erstellen
        updatedStats = [newStats];
    } else {
        // Eintrag vorhanden, stats erweitern
        updatedStats = [...existingPlayerEntry.stats, newStats];
    }

    // Speichere den aktualisierten Spieler zurück in den Speicher
    await db.put(STORE_PLAYER_STATS, { id: playerId, stats: JSON.parse(JSON.stringify(updatedStats)) });
};
export const saveScore = async (score) => {
    const db = await initDB();
    await db.put(STORE_SCORE, { id: score.id, score: JSON.parse(JSON.stringify(score)) });
};

export const loadScore = async (id) => {
    const db = await initDB();
    return await db.get(STORE_SCORE, Number(id));
};


export const loadAllScoreResult = async () => {
    const db = await initDB();
    const allGames = await db.getAll(STORE_SCORE);

    return allGames.map((entry, index) => {
       // Nehme den ersten Eintrag im game.game Array (oder überprüfe weitere Elemente, falls benötigt)
        const score = entry.score;
        const homeTeam = score.teams.find((t) => t.teamSide === 'home');
        const guestTeam = score.teams.find((t) => t.teamSide === 'guest');

        return {
            id: entry?.id || `Unknown ID ${index}`, // Fallback-ID
            name: `${guestTeam.name} vs ${homeTeam.name}`, // Formatierter Spielname
            score: `${ score?.inning?.[0]?.play?.[0]?.score?.guest }:${ score?.inning?.[0]?.play?.[0]?.score?.home }`, // Formatierter Spielname
            inning: score?.inning.length || 1,
            status: score?.status || false
        };
    });
};
export const saveOfficial = async (official) => {
    const db = await initDB();
    // Prüfe, ob ein Official mit dem gleichen Namen bereits existiert
    const allOfficials = await db.getAll(STORE_OFFICIALS);
    const existingOfficial = allOfficials.find(entry => entry.official.name === official.name);

    if (existingOfficial) {
        console.warn(`Official with name "${official.name}" already exists.`);
        return; // Abbrechen, wenn der Official bereits existiert
    }
    await db.put(STORE_OFFICIALS, { id: official.id, official: JSON.parse(JSON.stringify(official)) });
};
export const loadOfficial = async (id) => {
    const db = await initDB();
    return await db.get(STORE_OFFICIALS, Number(id));
};
export const loadAllOfficials = async () => {
    const db = await initDB();
    const allOfficials = await db.getAll(STORE_OFFICIALS);
    return allOfficials.map(entry => entry.official);
};
export const deleteOfficial = async (id) => {
    const db = await initDB();
    await db.delete(STORE_OFFICIALS, id);
};